import { FIELD_TYPES } from "constants/template-field-type";
import FullParagraphFieldConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import buttonConfig from "segments/desktop/core-components/button/fields-config";
import { SPACE_BLUE_GRADIANT_THEME_ID } from "segments/segments-service";
import SquareTagsFieldsConfig from "segments/desktop/core-components/square-tags/fields-config";

const { textAlign, mobileTextAlign, textColor, topic, buttonConfig: button, ...restFullParagraphFieldsConfig } = FullParagraphFieldConfig;
const { theme, ...restSquareTagsFieldsConfig } = SquareTagsFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Monday Universe",
  fields: {
    theme: {
      type: FIELD_TYPES.COLOR_PICKER,
      label: "Theme",
      possibleColors: [SPACE_BLUE_GRADIANT_THEME_ID]
    },
    fullParagraph: {
      type: FIELD_TYPES.NESTED,
      label: "Full paragraph",
      fields: restFullParagraphFieldsConfig
    },
    ...restSquareTagsFieldsConfig,
    lines: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Lines",
      maxLimit: 3,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          start: {
            type: FIELD_TYPES.NESTED,
            label: "Start point",
            fields: {
              top: {
                type: FIELD_TYPES.TEXT,
                label: "Top"
              },
              left: {
                type: FIELD_TYPES.TEXT,
                label: "Left"
              }
            }
          },
          end: {
            type: FIELD_TYPES.NESTED,
            label: "End point",
            fields: {
              top: {
                type: FIELD_TYPES.TEXT,
                label: "Top"
              },
              left: {
                type: FIELD_TYPES.TEXT,
                label: "Left"
              }
            }
          }
        }
      }
    }
  }
};
